import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1100px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-semibold mb-3">
              平台特色
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              为什么选择每日大赛
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mt-3">
              四大核心优势，打造最纯粹的娱乐PK投票体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {featuresData.map((feature, index) => (
              <div
                key={feature.id}
                className="group bg-background-100 rounded-2xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer text-center"
              >
                <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl flex items-center justify-center ${
                  index % 2 === 0 ? 'bg-primary-100' : 'bg-accent-100'
                }`}>
                  <i className={`${feature.icon} text-2xl ${index % 2 === 0 ? 'text-primary-500' : 'text-accent-500'}`}></i>
                </div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}